import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  Dashboard: {
    flexGrow: 1,
    overflow: 'auto',
    height: '100%',
    padding: '24px',
  },
  Table: {
    width: '100%',
    borderRadius: '12px',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)',
  },
  Scrollbar: {
    height: 'calc(100dvh - 244px)',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
      backgroundColor: '#f5f5f5',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#555',
    },
  },
  Footer: {
    width: '100%',
    display: 'flex',
    gap: '16px',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: '16px',
    borderTop: '1px solid var(--Gray-200, #EAECF0)',
  },
  RadioGroup: {
    display: 'flex',
    flexDirection: 'column',
    '& .MuiButtonBase-root ': {
      padding: '2px',
    },
    '& .MuiFormControlLabel-label': {
      marginLeft: '4px',
      fontSize: '13px',
      fontWeight: 600,
    },
  },
}));

export { useStyles };

